module.exports = __webpack_public_path__ + "static/img/home-overEn.eb303969.png";